import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SnackbarComponent } from '../snackbar/snackbar.component';
import Swal from 'sweetalert2';
@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private _router: Router, public dialog: MatDialog) {

  }

  successSnackBar(message: string, router: string) {
    this.dialog.open(SnackbarComponent, {
      data: {
        autoClose: true,
        message: message,
        router: router
      }
    });
  }

  show(message: string, router: string) {
    this.dialog.open(SnackbarComponent, {
      data: {
        autoClose: false,
        message: message,
        router: router,
      }
    });
  }

  alertWithConfirmations(message, color='#3085d6'){
    return Swal.fire({
        title: message,
        icon: 'warning',
        showClass: {
            popup: 'productEnable'
        },
        showCancelButton: true,
        confirmButtonText: 'OK',
        confirmButtonColor: color
    })
}

alertWithConfirmationsWithOutCancel(message,color='#3085d6'){
  return Swal.fire({
      title: message,
      icon: 'warning',
      showClass: {
          popup: 'productEnable'
      },
      // showCancelButton: true,
      confirmButtonText: 'OK',
      confirmButtonColor: color
  })
}

alert(message){
  return Swal.fire({
      icon: 'warning',
      text:message,
      confirmButtonColor: '#3085d6'
  })
}

showSuccess(message){
  return Swal.fire({
    icon: 'success',
    text:message
  })
}
}
